/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { GetRelevantContactsListQueryResponse, GetRelevantContactsListQueryParams, GetRelevantContactsListHeaderParams, GetRelevantContactsList401 } from "../../models/contactsController/GetRelevantContactsList";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getRelevantContactsListQueryKey = (params?: GetRelevantContactsListQueryParams) => [{ url: '/contacts/relevant' }, ...(params ? [params] : [])] as const

export type GetRelevantContactsListQueryKey = ReturnType<typeof getRelevantContactsListQueryKey>

/**
 * {@link /contacts/relevant}
 */
export async function getRelevantContactsList(params?: GetRelevantContactsListQueryParams, headers?: GetRelevantContactsListHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetRelevantContactsListQueryResponse, ResponseErrorConfig<GetRelevantContactsList401>, unknown>({ method : "GET", url : `/contacts/relevant`, params, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function getRelevantContactsListQueryOptions(params?: GetRelevantContactsListQueryParams, headers?: GetRelevantContactsListHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getRelevantContactsListQueryKey(params)
        return queryOptions<GetRelevantContactsListQueryResponse, ResponseErrorConfig<GetRelevantContactsList401>, GetRelevantContactsListQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getRelevantContactsList(params, headers, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /contacts/relevant}
 */
export function useGetRelevantContactsList<TData = GetRelevantContactsListQueryResponse, TQueryData = GetRelevantContactsListQueryResponse, TQueryKey extends QueryKey = GetRelevantContactsListQueryKey>(params?: GetRelevantContactsListQueryParams, headers?: GetRelevantContactsListHeaderParams, options: 
{
  query?: Partial<QueryObserverOptions<GetRelevantContactsListQueryResponse, ResponseErrorConfig<GetRelevantContactsList401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getRelevantContactsListQueryKey(params)
         

         const query = useQuery({
          ...getRelevantContactsListQueryOptions(params, headers, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetRelevantContactsList401>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}